import axios from "axios";
import showMessage from "@/utils/showMessage";
import { Message } from "element-ui";
import router from "@/router";

const ins = axios.create({
  // baseURL: "http://192.168.0.106:2024/"
  baseURL: "http://82.156.224.151:2024/"
}); // 创建一个axios的实例

// 请求拦截器：除 /api/login 外，在所有请求头中加入 Authorization（来自 cookie token）
ins.interceptors.request.use(function(config) {
  try {
    const url = config.url || "";
    if (url.includes("/api/login")) {
      // 登录接口不添加 Authorization
      return config;
    }
    const match = document.cookie.match("(?:^|; )token=([^;]*)");
    const token = match ? decodeURIComponent(match[1]) : null;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = token;
    }
  } catch (err) {
    // 忽略读取 cookie 的错误，继续请求
  }
  return config;
}, function(error) {
  return Promise.reject(error);
});

ins.interceptors.response.use(function(resp) { //响应拦截器
  // 检查响应头是否有token
  const token = resp.headers && resp.headers.authorization;
  if (token) {
    // 写入cookie，设置expires为2099年，强制永久
    document.cookie = `token=${token};path=/;expires=Fri, 31 Dec 2099 23:59:59 GMT`;
  }

  console.log("响应拦截器", resp && resp.status, resp && resp.data && resp.data.code);
  // 如果 HTTP 状态码是 401，或后端返回的业务 code 为 401，则弹出错误并跳转到登录页
  if (resp.status === 401 || (resp.data && resp.data.code === 401)) {
    console.log("未授权，跳转登录");
    const msg = (resp.data && resp.data.msg) || resp.statusText || '未授权，请登录';
    // 使用 Element UI 的 Message.error 显示错误信息
    Message.error(msg);
    // 跳转到登录页
    router.push('/login');
    // 抛出响应，方便调用方在 catch 中读取服务器返回的 data
    return Promise.reject(resp);
  }

  if (resp.data && resp.data.code !== 0) {
    console.log(resp.data.msg);
    showMessage({
      content: resp.data.msg,
      type: (resp.data.msg == "没有数据" ? "warn" : "error"),
      duration: 3000,
    });
    // 抛出响应，便于页面在 catch 中读取 resp.data.data 的额外信息
    return Promise.reject(resp);
  }
  return resp.data && resp.data.data;
});

export default ins;
